<div class="rating-wrapper" [style]="containerStyle()">
  
  <div class="glass-container">
    @for (glass of glasses; track $index) {
      <div class="glass-item" [id]="'glass-' + $index">
        <!-- Empty glass (background) -->
        <div class="glass-svg empty"></div>
        
        <!-- Filled portion (overlay from bottom) -->
        @if (getGlassFillPercentage($index) > 0) {
          <div class="glass-fill" [style.height.%]="getGlassFillPercentage($index)">
            <div class="glass-svg filled" [style.height]="'100cqh'"></div>
          </div>
        }
      </div>
    }
  </div>

  @if (!readonly()) {
    <ion-range
      min="0"
      max="5"
      step="0.1"
      [value]="rating()"
      (ionInput)="onSliderInput($event)"
      class="rating-slider"
      data-testid="beer-form-rating">
    </ion-range>
  }
</div>